<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('academic_profile').toUpper() }}</h5>
        <b-card class="soft mb-5">
            <b-row>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('academic_year_of_registration') }}</label>
                        <div>
                            <span>{{ getObjectValue(studentProgram, 'registration_semester_academic_year') }} </span>
                            <span>&nbsp;-&nbsp;</span>
                            <span>{{ studentProgram.registration_semester ? this.getSemester(studentProgram.registration_semester) : '-' }}</span>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_date') }}</label>
                        <div>{{ studentProgram.registration_date ? this.toLocaleDate(studentProgram.registration_date) : '-' }}</div>
                    </div>
                </b-col>
                <b-col v-if="isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_start_date') }}</label>
                        <div>{{ studentProgram.registration_start_date ? this.toLocaleDate(studentProgram.registration_start_date) : '-' }}</div>
                    </div>
                </b-col>
                <b-col v-if="isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_term') }}</label>
                        <div>{{ studentProgram.registration_term || '-' }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_module') }}</label>
                        <div>
                            {{ studentProgram.first_module_name ? studentProgram.first_module_name : '-' }}
                        </div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_session') }}</label>
                        <div>
                            {{ studentProgram.first_session_number ? studentProgram.first_session_number : '-' }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_type') }}</label>
                        <div>{{ studentProgram.registration_type_text }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('legal_presence_type') }}</label>
                        <div>{{ studentProgram.legal_presence_type }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('student_status') }}</label>
                        <div>{{ studentProgram.student_status_text }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ isTeflProgram ? $t('term_status') : $t('module_status') }}</label>
                        <div>{{ studentProgram.active_module_status }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('re_enrollment') }}</label>
                        <div>{{ studentProgram.re_enrollment }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('reinstatement') }}</label>
                        <div>{{ studentProgram.reinstatement }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('transfer_out_destination') }}</label>
                        <div>{{ studentProgram.to_university_name }}</div>
                    </div>
                </b-col>

                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('program_path') }}</label>
                        <div>{{ getObjectValue(studentProgram, 'program_path') }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('esl_group_name') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'esl_group_name') }}
                        </div>
                    </div>
                </b-col>

                <b-col v-if="!isYouthProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('esl_placement_score') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'esl_placement_score') }}
                        </div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('placement_exam_test') }}</label>
                        <div>{{ studentProgram.placement_exam_level_name || "-" }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('cefr_initial_level') }}</label>
                        <div>{{ studentProgram.cefr_level || "-" }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('cefr_level_current') }}</label>
                        <div>{{ studentProgram.cefr_level_current || "-" }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('cefr_level_completed') }}</label>
                        <div>{{ studentProgram.cefr_level_completed || "-" }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('academic_probation') }}</label>
                        <div>{{ studentProgram.academic_probation || "-" }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('appeal_letter') }}</label>
                        <div>{{ studentProgram.appeal_letter || "-" }}</div>
                    </div>
                </b-col>
                <b-col v-if="!isYouthProgram" cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('behavior_probation') }}</label>
                        <div>{{ studentProgram.behavior_probation || "-" }}</div>
                    </div>
                </b-col>
              <b-col v-if="!isYouthProgram && !isTeflProgram" cols="6">
                <div class="label-as-input-div">
                  <label>{{ $t('ce_course') }}</label>
                  <div>{{ studentProgram.ce_course || "-" }}</div>
                </div>
              </b-col>
            </b-row>
        </b-card>
        <b-row>
            <b-col v-if="!isYouthProgram" cols="12" lg="6">
                <b-card :header="isTeflProgram ? $t('completion_information') : $t('graduation_information')" class="soft mb-5">
                    <b-row>
                        <b-col v-if="!isTeflProgram" cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('completion_module') }}</label>
                                <div>
                                    {{ getObjectValue(studentProgram, 'completion_module','') }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('completion_decision_date') }}</label>
                                <div>{{ studentProgram.graduation_date ? this.toLocaleDate(studentProgram.graduation_date) : '-' }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('leaving_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('reason_for_leaving') }}</label>
                                <div>
                                    {{ studentProgram.leaving_reason_name }}
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="!isTeflProgram" cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('leaving_module') }}</label>
                                <div>
                                    {{ getObjectValue(studentProgram, 'leaving_module','') }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('leaving_date') }}</label>
                                <div>{{ studentProgram.leaving_date ? studentProgram.leaving_date: '-' }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_mentora') && editMode">
            {{ $t('edit') }}
        </b-button>
        <CommonModal ref="formModal"
                     size="lg"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_mentora') && editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('mentora').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    import ConstantService from "@/services/ConstantService";

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null,
            }
        },
        computed: {
            isYouthProgram() {
                return this.studentProgram?.program_code === '0702004'
            },
            isTeflProgram() {
              return this.studentProgram?.program_code === '0702006'
            }
        },
        created() {

        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

